import { Injectable } from '@angular/core'
import { BaseSignalStore } from '@core/state/base-store'
import {
  ActifNetDto,
  DocumentNotaireVracDto,
  EtatForcesChargesResponseDto,
  LigneActifDto,
  LignePassifDto
} from '@shared/models/dto/api-dtos'

export interface EtatForcesChargesState {
  dossierSuccessionId: number | null
  documents: DocumentNotaireVracDto[]
  actif: LigneActifDto[]
  passif: LignePassifDto[]
  actifNet: ActifNetDto | null
  autresInformations: string | null
}

@Injectable({ providedIn: 'root' })
export class EtatForcesChargesStore extends BaseSignalStore<EtatForcesChargesState> {
  constructor() {
    super({
      dossierSuccessionId: null,
      documents: [],
      actif: [],
      passif: [],
      actifNet: null,
      autresInformations: null
    })
  }

  readonly dossierSuccessionId = this.select(state => state.dossierSuccessionId)
  readonly documents = this.select(state => state.documents)
  readonly actif = this.select(state => state.actif)
  readonly passif = this.select(state => state.passif)
  readonly actifNet = this.select(state => state.actifNet)
  readonly autresInformations = this.select(state => state.autresInformations)

  setEtatForcesCharges(payload: EtatForcesChargesResponseDto): void {
    this.setState({
      dossierSuccessionId: payload.dossierSuccessionId,
      documents: payload.documentsNotaireVrac ?? [],
      actif: payload.actif ?? [],
      passif: payload.passif ?? [],
      actifNet: payload.actifNet ?? null,
      autresInformations: payload.autresInformations ?? null
    })
  }

  setSearchResults(documents: DocumentNotaireVracDto[]): void {
    this.setState({ documents })
  }
}

